// redux/reducers/index.js

import {FETCH_AUTORIDADES_SUCCESS,FETCH_AUTORIDADES_FAILURE} from '../actions/autoridades/types';

const initialState = {
  data: [],
  error: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUTORIDADES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case FETCH_AUTORIDADES_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer;
